module.exports = __webpack_public_path__ + "img/cloud_2_act.7f1fcf17.svg";